import React from "react";
import { connect } from "react-redux";
import { logout } from "../redux/actions/api_auth";
import { googleLogout } from "../redux/actions/google_auth";
import { Link } from "react-router-dom";
import { Avatar } from "@mui/material";
import LetterAvatar from "./LetterAvatar";

import {
  Collapse,
  Navbar as NavbarRS,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  NavbarBrand,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DropdownHover from "./DropdownHover";

import { Settings, User, HelpCircle } from "react-feather";
import "../assets/styles/Navbar.scss";

class Navbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      userData: {},
    };
  }

  toggleNavbar = () => {
    this.setState(
      (prevState) => ({
        isOpen: !prevState.isOpen,
      }),
      () => {
        this.props.setSticky(this.state.isOpen);
      }
    );
  };

  render() {
    const { isOpen } = this.state;
    const { isAuthenticated, user } = this.props.auth;
    const isSignedIn = localStorage.getItem("isSignedIn");
    const userData = JSON.parse(localStorage.getItem("userData"));
    const { modifiers } = this.props;

    let name;
    let profile_picture;

    // console.log("isSignedIn:", isSignedIn);
    // console.log("userData:", userData);
    if (isSignedIn) {
      name = userData.given_name;
      profile_picture = userData.picture;
      // console.log(profile_picture);
    }
    // console.log("navbar test isAutehtnicated:", this.props.auth);
    // console.log("navbar test google:", this.props.googleLoginAuth);
    const modifierClasses = modifiers.length
      ? modifiers.reduce((result, modifier) => {
          result = `${result} ${modifier}`;
          return result;
        }, "")
      : "";

    const logoPath = modifierClasses
      ? require("../assets/img/logo_navbar_dark.png")
      : require("../assets/img/logo_navbar.png");

    const authLinks = (
      <DropdownHover>
        <DropdownToggle nav caret id="profile-menu">
          {/* <LetterAvatar
            name={name ? name : ""}
            profile_picture={profile_picture}
            size={32}
            radius={32}
            customColor={[255, 214, 62, 0.8]}
            inline
          /> */}
          <Avatar src={profile_picture} alt={""} />
          <span className="ml-2">{user ? user.full_name : ""}</span>
        </DropdownToggle>
        <DropdownMenu right>
          <Link to="/profile">
            <DropdownItem>
              <User size={18} className="align-middle mr-2" /> 프로필
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          <Link to="/profile/settings">
            <DropdownItem>
              <Settings size={18} className="align-middle mr-2" /> 설정
            </DropdownItem>
          </Link>
          <Link to="/help">
            <DropdownItem>
              <HelpCircle size={18} className="align-middle mr-2" /> 도움
            </DropdownItem>
          </Link>
          <DropdownItem onClick={this.props.googleLogout}>Logout</DropdownItem>
        </DropdownMenu>
      </DropdownHover>
    );

    const guestLinks = <React.Fragment></React.Fragment>;

    return (
      <NavbarRS
        className={modifierClasses ? modifierClasses : "navbar-dark"}
        expand="md"
      >
        <NavbarBrand href="/">
          <img src={`${logoPath}`} width="200" height="45" alt="logo" />
        </NavbarBrand>
        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />

        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <DropdownHover>
              <DropdownToggle nav caret>
                University
              </DropdownToggle>
              <DropdownMenu right>
                <Link to="/page/class/alevel">
                  <DropdownItem>A-Level</DropdownItem>
                </Link>
                {/* <Link to="/page/class/blockchain">
                  <DropdownItem>Blockchain</DropdownItem>
                </Link> */}
                <DropdownItem divider />
                <Link to="/page/class/ib">
                  <DropdownItem>IB Diploma</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/page/class/igcse">
                  <DropdownItem>IGCSE</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/page/class/ielts">
                  <DropdownItem>IELTS / TOEFL</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/page/class/uniadm">
                  <DropdownItem>University Admission Test</DropdownItem>
                </Link>
              </DropdownMenu>
            </DropdownHover>
            <DropdownHover nav inNavbar>
              <DropdownToggle nav caret>
                Experts School
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>의대, 치대</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>코딩 스쿨</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>스포츠 산업</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>법대</DropdownItem>
              </DropdownMenu>
            </DropdownHover>
            <DropdownHover nav inNavbar>
              <DropdownToggle nav caret>
                Premium Service
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>고등반 (TOP 5 명문대)</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>중등반 (IGCSE)</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>재수생 특별반</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>UCAS 지원서비스</DropdownItem>
              </DropdownMenu>
            </DropdownHover>
            <DropdownHover>
              <DropdownToggle nav caret>
                Career
              </DropdownToggle>
              <DropdownMenu right>
                <Link to="/page/career/data_scientist">
                  <DropdownItem>데이터 사이언티스트가 되고싶다면?</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/page/career/elon_musk">
                  <DropdownItem>제 2의 일론 머스크를 꿈 꾼다면?</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/page/career/cosmetic_create">
                  <DropdownItem>화장품은 어떻게 만들어질까?</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/page/career/economics">
                  <DropdownItem>경제 상식은 요즘 필수</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/page/career/doctor">
                  <DropdownItem>의대/치대를 위한 학생</DropdownItem>
                </Link>
                <Link to="/page/career/blockchain">
                  <DropdownItem>NFT,블록체인이 궁금하다면?</DropdownItem>
                </Link>
              </DropdownMenu>
            </DropdownHover>
            <DropdownHover nav inNavbar>
              <DropdownToggle nav caret>
                Online Classroom
              </DropdownToggle>
              <DropdownMenu right>
                <Link to="/page/classrooms/premium_classrooms">
                  <DropdownItem>1:1 Premium Class</DropdownItem>
                </Link>

                <DropdownItem divider />
                <DropdownItem>Group Class</DropdownItem>
              </DropdownMenu>
            </DropdownHover>
            <DropdownHover nav inNavbar>
              <DropdownToggle nav caret>
                Contact
              </DropdownToggle>
              <DropdownMenu right>
                <Link to="/contact/consult">
                  <DropdownItem>상담문의</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/contact/recruitment">
                  <DropdownItem>채용문의</DropdownItem>
                </Link>
                <DropdownItem divider />
                <Link to="/auth/teacher">
                  <DropdownItem>강사등록</DropdownItem>
                </Link>
                <DropdownItem divider />
                <DropdownItem>FAQ</DropdownItem>
              </DropdownMenu>
            </DropdownHover>
            {isSignedIn ? authLinks : guestLinks}
            {isSignedIn ? (
              ""
            ) : (
              <DropdownHover>
                <Link to="/auth/oauth_login">
                  <span className="login_button">로그인</span>
                </Link>
              </DropdownHover>
            )}
          </Nav>
        </Collapse>
      </NavbarRS>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.api_auth,
  googleLoginAuth: state.google_auth,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
  googleLogout: () => dispatch(googleLogout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
